import { createContext } from "react";
import { AppConfig, AppConfigDefault } from "./app-config";

export const AppConfigContext = createContext<AppConfig>(AppConfigDefault);
